import clsx from 'clsx';
import * as React from 'react';
import { ButtonColor } from './Button';

import styles from './UniLink.module.scss';

export type LinkProps = {
  title?: string;
  href?: string;
  color?: ButtonColor;
  className?: string;
  disabled?: boolean;
  icon?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  testId?: string;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const UniLink: React.FC<LinkProps> = (props) => {
  const { title, color, className, disabled, icon, testId, ...rest } = {
    ...defaultProps,
    ...props,
  };

  return (
    <a
      data-disabled={disabled}
      {...rest}
      className={clsx(styles.link, styles[`${color}-link`], className)}
      data-test-id={props.testId}
    >
      {icon}
      {title}
    </a>
  );
};

const defaultProps: Partial<LinkProps> = {
  color: ButtonColor.Primary,
};
